export function portfolioGridView() {
    const $parent = $(".portfolio-controls-holder");
    const $portfolioListHolder = $parent.parents(".section").find(".portfolio-listing-holder");
    const $container = $portfolioListHolder.find(".container");
    const $portfolioList = $portfolioListHolder.find(".portfolio-listing");
    let gridButton = $parent.find(".portfolio-grid-view-button");
    gridButton.on("click", function (event) {
        event.preventDefault();
        let $this = $(this);
        if (!$this.hasClass("active")) {
            gridButton.removeClass("active")
            if ($this.hasClass("portfolio-grid-chaotically")) {
                $this.addClass("active");
                $portfolioList.addClass("hide");
                setTimeout(function () {
                    $container.removeClass("medium");
                    $portfolioList.addClass("chaotically-grid").removeClass("three-in-line two-in-line hide");
                }, 550);
            }
            if ($this.hasClass("portfolio-grid-three")) {
                $this.addClass("active");
                $portfolioList.addClass("hide");
                setTimeout(function () {
                    $container.removeClass("medium");
                    $portfolioList.addClass("three-in-line").removeClass("chaotically-grid two-in-line hide");
                }, 550);
            }
            if ($this.hasClass("portfolio-grid-two")) {
                $this.addClass("active");
                $portfolioList.addClass("hide");
                setTimeout(function () {
                    $container.addClass("medium");
                    $portfolioList.addClass("two-in-line").removeClass("chaotically-grid three-in-line hide");
                }, 550);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/portfolioGridView.js